import { CryptoCore } from './core/crypto-core';

export const makeKeyPair = async (mnemonic: string) => {
  const cryptoCore = new CryptoCore();

  try {
    return await cryptoCore.mnemonicToKeyPair(mnemonic);
  } catch (er) {
    return null;
  }
};
